"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.productConfiguration = void 0;
const productConfiguration = exports.productConfiguration = {
  bgColor: "#46C3B2",
  textColor: "#FFFFFF",
  chipBgColor: "#CCFBEF",
  chipTextColor: "#005851"
};